module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper"
  }, [_c('v-sidebar', {
    attrs: {
      "activeNavItem": "map"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "main-panel"
  }, [_c('v-navbar', {
    attrs: {
      "title": 'Map'
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col text-right"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.trackerId),
      expression: "trackerId"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.trackerId = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "AT_003"
    }
  }, [_vm._v("\n                  Dummy Device (AT_003)\n                ")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "6511"
    }
  }, [_vm._v("\n                  Blue Rover (6511)\n                ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col col-2 points-list"
  }, [_c('ul', _vm._l((_vm.points), function(point, index) {
    return _c('li', {
      key: index
    }, [_vm._v("\n                  " + _vm._s(point.tooltip) + "\n                ")])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "col "
  }, [_c('LeafletMap', {
    attrs: {
      "fit-to-markers": "",
      "height": "600px",
      "points": this.points,
      "lines": this.lines
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.startdate),
      expression: "startdate"
    }],
    staticClass: "form-control datetimepicker",
    attrs: {
      "id": "startdate",
      "type": "text"
    },
    domProps: {
      "value": (_vm.startdate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.startdate = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.enddate),
      expression: "enddate"
    }],
    staticClass: "form-control datetimepicker",
    attrs: {
      "id": "enddate",
      "type": "text"
    },
    domProps: {
      "value": (_vm.enddate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.enddate = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row mt-4"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('button', {
    on: {
      "click": _vm.loadBlueRoverData
    }
  }, [_vm._v("\n                Load Points\n              ")])]), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('button', {
    on: {
      "click": _vm.resetDateInputs
    }
  }, [_vm._v("\n                Reset Dates\n              ")])])])])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e7032872"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/map/MapPage.vue
// module id = 778
// module chunks = 0